import { React, useEffect, useState, useRef } from 'react'
import { motion } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { Card, CardHeader, CardBody } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPen, faUsers, faUserShield, faGift, faUserCog, faListCheck, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../CustomerPortal.css';

const Sevice_types = [
    {
        name: "User Details",
        icon: faUserPen,
        setSelcted: 1

    },
    {
        name: "Nominees Details",
        icon: faUsers,
        setSelcted: 2
    }, {
        name: "Assignee Details",
        icon: faUserCog,
        setSelcted: 3
    }
    ,
    {
        name: "Guardian Details",
        icon: faUserShield,
        setSelcted: 4
    }
    ,
    
    
    {
        name: "Requests",
        icon: faListCheck,
        setSelcted: 6
    }

]
const CustomerServiceMenu = ({setSelectedService}) => {
  return (
    <Row style={{ width: "100%" }} className='my-2 d-flex justify-content-center'>
    {
        Sevice_types.map((value, index) => {
            return (

                <Col lg={3} md={3} sm={6} xs={6} key={`service_types_key_${index}`}>
                    <motion.div
                        initial={{
                            y: "50%",
                            opacity: 0
                        }}
                        animate={{
                            y: "0%",
                            opacity: 1,
                            transition: { duration: 0.3, delay: (0.1 * index) }
                        }}
                        whileHover={{
                            scale: 0.9,
                            transition: { duration: 0.1 },
                           
                        }}

                        onClick={() => { setSelectedService(value.setSelcted) }}
                    >
                        <Card className="py-4 my-4"  style={{ width: "100%", height: "30vh" , backgroundColor:"#86A7FC", cursor: "pointer"}}>

                            <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center" }}>
                                <FontAwesomeIcon icon={value.icon} className='my-3' style={{ height: "3vh" }} />
                                <p style={{ fontSize: "15px", width: "75%", fontWeight:"bold"}} >{value.name}</p>

                            </CardBody>
                        </Card>
                    </motion.div>
                </Col>

            )

        })
    }
</Row>
  )
}

export default CustomerServiceMenu
